/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
import './BoiRetrieveCard.scss';

import { CardWrapper, Text } from '@boi/core/lib';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { CognitoContext } from '../../CognitoUtils';
import { primaryBlue } from '../../constants/colors';
import { HOME_RESUME_QUOTE } from '../../constants/sessionStorage/homeStorageIdentifiers';
import { saveInSessionStorage } from '../../helpers';
import { routes } from '../../routes';
import type { UserProfileType } from '../../types/profile';

type Props = {
  userProfile: UserProfileType
};

type TableDetails = {
  policyCode: ?string,
  premium: ?string
};

export const BoiRetrieveCard = ({ userProfile }: Props) => {
  const className = 'c-BoiRetrieveCard';

  let quoteDetails = userProfile.quote;
  const { feature } = useContext(CognitoContext);
  const history = useHistory();

  const formatPremium = (premium: ?number): ?string => {
    const numericValue = parseFloat(premium);
    if (!isNaN(numericValue)) {
      return numericValue.toString().includes('.')
        ? numericValue.toFixed(2)
        : numericValue % 1 !== 0
        ? numericValue.toFixed(1)
        : numericValue.toFixed(2);
    }
  };

  const tableDetails: TableDetails = {
    policyCode: quoteDetails.policy_code,
    premium: formatPremium(quoteDetails.cover_premium)
  };

  const handleClick = (e: SyntheticMouseEvent<HTMLElement>) => {
    saveInSessionStorage(HOME_RESUME_QUOTE, true);
    [
      `${routes.getQuotePage.url}aboutYou`,
      `${routes.getQuotePage.url}yourHome`,
      `${routes.getQuotePage.url}yourCover`,
      `${routes.termsAndConditions.url}home`,
      `${routes.viewQuote.url}home`
    ].forEach(history.push);
    if (feature.flags?.marketing_enabled) {
      history.push(`${routes.marketingConsent.url}home`);
    }
    e.preventDefault();
  };

  return (
    <div className={className}>
      <CardWrapper>
        <Link
          to=""
          className={`${className}__link`}
          data-ga
          id="WalletLanding__resumeQuoteLink"
          data-testid="WalletLanding__resumeQuoteLink"
          onClick={handleClick}
        >
          <div className={`${className}__cardContents`}>
            <div className={`${className}__icon`}>
              <FontAwesomeIcon icon={faHome} style={{ color: primaryBlue }} />
            </div>
            <div className={`${className}__cardInformation`}>
              <div className={`${className}__cardText`}>
                <Text align="left">
                  <b>Continue with your latest Home quote</b>
                </Text>
              </div>
              <div className={`${className}__cardDetails`}>
                <Text align="left">
                  {/*Quote ref used as display name to stay consistent with emails at request of customer, value presented is correct in being policy code and not quote reference*/}
                  <b>Quote Ref:</b> {tableDetails.policyCode}
                </Text>
                <Text align="left">
                  <b className={`${className}__premiumTitle`}>Premium:</b>€
                  {tableDetails.premium}
                </Text>
              </div>
            </div>
          </div>
        </Link>
      </CardWrapper>
    </div>
  );
};

export default BoiRetrieveCard;
